export const routes = {
    DEFAULT: '/',
} as const;
